import { TaiLieu } from "./TaiLieu";

export class KhenThuong {
    "id": number;
    "idNhanVien": number;
    "ngayQuyetDinh": Date;
    "soQuyetDinh": string;
    "thanhTichKhenThuong": string;
    "hinhThucKhenThuong": string;
    "nguoiKy": string;
    "chucVuNguoiKy": string;
    "capThanhTich": string;
    "donViKyQuyetDinh": string;
    "dsTaiLieu": Array<TaiLieu>;
}